module.exports = {
	"account.user.driving.licence.already.exist": "Ya existe otra cuenta con este número de permiso de conducir.",
	"account.user.login.already.exist": "Este correo electrónico ya está siendo utilizado por otra cuenta.",
	"account.user.suspended": "No se puede realizar esta acción porque el usuario está suspendido",
	"action.add.payment": "Añadir un método de pago",
	"action.complete.my.account": "Completa mi cuenta",
	"action.confirm.welcome.msg": "Vamos",
	"action.create.my.account": "Crear mi cuenta",
	"action.search.update.bookings": "Comprobar disponibilidades",
	"action.update.payment": "Actualizar el método de pago",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Al pulsar \"Confirmar\", declaras aceptar las condiciones del servicio y, si eres el conductor, poseer un permiso de conducir válido. Más en el {link}.",
	"booking.accept_usage_terms.title": "Condiciones generales de utilización",
	"booking.action.cancel.forbidden": "Ya no puedes cancelar la reserva.",
	"booking.action.edit.forbidden": "Ya no puedes editar una reserva",
	"booking.add.calendar": "Añadir al calendario",
	"booking.confirm": "Confirmar reserva",
	"booking.confirm_and_pay": "Confirmar y pagar",
	"booking.deposit": "Depósito de seguridad",
	"booking.deposit.b": "Se cargará un depósito bancario de {damageSafetyDeposit} {currency} cuando confirme su reserva.\n Este depósito se puede utilizar para cubrir cualquier daño causado al vehículo durante su viaje. \n\n Si el vehículo se devuelve sin daños ni horas extra, solo se {bookingPrice} {currency} .",
	"booking.deposit.d": "Se realizará un depósito bancario por la cantidad de {bufferPrice} {currency} cuando confirme su reserva.\n Esto incluye el precio de su reserva y un cargo para cubrir cualquier exceso. \n\n Sin un exceso de tiempo ni daños en el vehículo, solo se {bookingPrice} {currency} de su cuenta.",
	"booking.deposit.db": "Se cobrarán dos depósitos bancarios cuando confirme su reserva:\n - Primero uno por la cantidad de {bufferPrice} {currency} , incluido el precio de su reserva y un cargo para cubrir cualquier exceso.\n - Segundo por la cantidad de {damageSafetyDeposit} {currency} para cubrir cualquier daño causado al vehículo durante su reserva. \n\n Sin ningún exceso o daño del vehículo, solo se {bookingPrice} {currency} .",
	"booking.deposit.info": "Se colocará un depósito por su reserva.",
	"booking.payment.prebilling.refused.error": "La transacción ha sido rechazada por un error en el cargo a su tarjeta de crédito. Pruebe con otra tarjeta. Si el problema persiste, consulte con su banco.",
	"booking.payment.prebilling.technical.error": "Se ha producido un error durante el pago. Inténtelo de nuevo más tarde.",
	"booking.success.sub.title": "¡Gracias por usar nuestro servicio!",
	"booking.success.title": "¡Felicidades, su reserva se ha creado con éxito!",
	"booking.type.label": "Tipo de reserva",
	"booking.type.one_way": "Solo ida",
	"booking.type.return_trip": "Ida y vuelta",
	"booking.update.period.expired": "El periodo para actualizar las fechas de reserva ha expirado",
	"booking.usage.business": "Profesional",
	"booking.usage.private": "Particular",
	"booking.view_payment_terms.title": "Forma de pago",
	"booking.voucher.different.code": "No puede modificar su código promocional",
	"booking.voucher.placeholder": "Tengo un cupón descuento",
	"car.AUTOMATIC": "Automático",
	"car.DIESEL": "Diésel",
	"car.ELECTRIC": "Eléctrico",
	"car.FOLDING_SEATS": "Asientos abatibles",
	"car.GPS": "GPS",
	"car.HYBRID": "Híbrido",
	"car.LPG": "GPL",
	"car.MANUAL": "Manual",
	"car.PETROL": "Gasolina",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Detalles de la reserva",
	"car.color": "Color",
	"car.compact_cars": "Compacto",
	"car.description": "Description",
	"car.details": "Detalles del vehículo",
	"car.doors": "Puertas",
	"car.filter.COMMERCIAL": "Comercial",
	"car.filter.PASSENGER": "Turismo",
	"car.filter.accessories.air_conditioning": "Aire condicionado",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Camión grande",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Número de personas",
	"car.filter.other": "Otros",
	"car.filter.other-nb": "Otros — {nb}",
	"car.filter.vehicle_type": "Tipo de vehículo",
	"car.filter_energy": "Energía",
	"car.filter_gearbox_type": "Tipo de caja de cambios",
	"car.filter_persons": "personas",
	"car.for_every_additional_km": "Por kilómetro adicional",
	"car.km_included": "Km incluidos",
	"car.motorization": "Motorización",
	"car.options": "Opciones",
	"car.parking_additional_info": "Detalles específicos de estacionamiento",
	"car.places": "Asientos",
	"car.pricing": "Precios",
	"car.pricing.estimate": "Precio estimado",
	"car.pricing.extra_km_cost_per_day": "Precio del km extra",
	"car.pricing.free_km_per_day": "Km incluido / 24 h",
	"car.specifications": "Especificaciones",
	"car.transmission": "Tipo de cambio",
	"car.utility_cars": "Utilitario",
	"car.version": "Versión",
	"company.id.missing.booking.search": "La identificación de la empresa es obligatoria para la búsqueda de reserva anónima",
	"contact_page.phone_call_price": "(LLAMADA GRATUITA DESDE UN TELÉFONO FIJO)",
	"contact_page.title_1": "Para cualquier duda sobre el alquiler de su coche,",
	"contact_page.title_2": "no dude en ponerse en contacto con nosotros por correo electrónico.",
	"creditcard.data.insufficient.3ds": "Debido a los nuevos requisitos de 3DS2, le pedimos que actualice su información de pago.",
	"custom.field.type.boolean": "Si/No",
	"data.with.colon": "{data}:",
	"document.issue.date": "Fecha de expedición",
	"dropzone.inner.info": "Archivos permitidos: JPEG, PNG, PDF",
	"dropzone.inner.title": "Suba su documento",
	"error.booking.member_invalid": "Su perfil aún no ha sido validado.",
	"error.booking.no.usage": "Sin uso para estas fechas de reserva",
	"error.booking.no_credit_card": "Primero agregue la información de su tarjeta de crédito.",
	"error.booking.same_period": "Ya tiene una reserva planificada para este período.",
	"error.change_password.400.bad_request": "La contraseña es incorrecta",
	"error.contract.inactive": "El servicio no está activo para su empresa, póngase en contacto con su gerente de servicio.",
	"error.contract.not-found": "Su empresa ha suspendido el servicio, póngase en contacto con su gerente de servicio.",
	"error.credit.card.refused": "Tarjeta de crédito rechazada",
	"error.forgot_password.404": "Compruebe su correo electrónico, no hay ninguna cuenta que coincida",
	"error.form.email.already_exists": "Introduzca una dirección de correo electrónico diferente",
	"error.form.email_invalid": "Introduzca una dirección de correo electrónico válida",
	"error.form.inviteCode.notEmpty": "Proporcione un código de invitación",
	"error.form.password.at_least": "Su contraseña debe contener al menos 8 caracteres",
	"error.form.password.at_most": "Su contraseña debe contener un máximo de 25 caracteres",
	"error.form.password.cannot_reset_same": "Su nueva contraseña debe ser diferente a la actual",
	"error.form.password.digit": "Su contraseña debe contener un número",
	"error.form.password.lower_letter": "Su contraseña debe contener una letra minúscula",
	"error.form.password.upper_letter": "Su contraseña debe contener una letra mayúscula",
	"error.form.password_confirmation.the_same": "Introduzca la misma contraseña dos veces",
	"error.form.password_old.the_same": "La nueva contraseña debe ser diferente de las contraseñas utilizadas anteriormente",
	"error.form.required": "Complete todos los campos obligatorios",
	"error.form.suggestion.address.required": "Seleccione la dirección de la lista de sugerencias",
	"error.form.technical": "Error técnico",
	"error.get.site.config": "No se pudo cargar la configuración del sitio",
	"error.invite.code.invalid": "La comunidad a la que quieres unirte no existe",
	"error.login.401.unauthorized": "Su correo electrónico o contraseña es incorrecto",
	"error.login.403.user.anonymized": "Su cuenta está siendo anonimizada, ya no puede usarla",
	"error.login.422.user.not.enabled": "Su cuenta no está activada, revise su correo electrónico y siga las instrucciones para activar la cuenta.",
	"error.number.above.max": "El valor no puede ser superior a {value}",
	"error.number.below.min": "El valor no puede ser inferior a {value}",
	"error.phone.format.invalid": "El formato del número de teléfono no es correcto",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Error de solicitud",
	"error.reset_password.401": "El enlace proporcionado ya no es válido, solicite otra contraseña en el sitio",
	"error.search.vehicles.403": "No puede acceder al sitio seleccionado con el perfil activo actual",
	"error.session.expired": "La sesión ha expirado",
	"error.text.length.long": "Este campo está limitado a {count} caracteres",
	"error.text.length.short": "Este campo debe tener al menos {count} caracteres",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "El nombre y la fecha de nacimiento no se pueden cambiar una vez que el perfil esté validado",
	"faq.contactEmailFallback": "nuestro correo electrónico de contacto",
	"faq.contactPhoneFallback": "la parte inferior de la página",
	"faq.other_question": "¿No encuentra la respuesta a su pregunta?",
	"file_upload_size_exceeded": "El archivo es demasiado grande. Talla máxima: 5 MB",
	"footer.label.legal.information": "Información legal",
	"footer.label.personal.data": "Información personal",
	"footer_callUs": "Llámenos",
	"footer_other": "Otros",
	"footer_share": "Síganos",
	"footer_society_about": "Sobre nosotros",
	"footer_society_policy_privacy": "Política de privacidad",
	"footer_society_term": "Condiciones de uso",
	"footer_writeUs": "Envíenos un correo electrónico",
	"forgot_password.confirmation": "Se ha enviado un enlace a su dirección de correo electrónico para restablecer su contraseña.",
	"forgot_password.description_line1": "Introduzca el correo electrónico asociado a su cuenta.",
	"forgot_password.description_line2": "Le enviaremos un enlace para restablecer su contraseña.",
	"forgot_password.submit": "Enviarme enlace de restablecimiento",
	"generic.address": "Dirección",
	"generic.at": "a",
	"generic.book": "Reservar",
	"generic.cancel": "Cancelar",
	"generic.canceled": "Cancelada",
	"generic.city": "Ciudad",
	"generic.clear": "Borrar",
	"generic.company": "Empresa",
	"generic.completed": "Completada",
	"generic.country": "País",
	"generic.email": "Correo electrónico",
	"generic.end": "Final",
	"generic.expires.at": "Caduca",
	"generic.extend": "Ampliar",
	"generic.file": "Fichero",
	"generic.first.name": "Nombre",
	"generic.last.name": "Apellidos",
	"generic.location.fixture.label": "Lugares",
	"generic.location.history.label": "Historia",
	"generic.location.search.placeholder": "Buscar una dirección, una ciudad...",
	"generic.mobile.phone": "Teléfono móvil",
	"generic.modify": "Modificar",
	"generic.mr": "Sr.",
	"generic.mrs": "Sra.",
	"generic.next": "Siguiente",
	"generic.number": "Número",
	"generic.passport": "Pasaporte",
	"generic.past.placeholder": "Encuentra aquí tus reservas pasadas",
	"generic.phone.number": "Número de teléfono",
	"generic.postal.code": "Código postal",
	"generic.retry": "Reintentar",
	"generic.save": "Guardar",
	"generic.send": "Enviar",
	"generic.start": "Comienzo",
	"generic.text": "Texto",
	"generic.today": "Hoy",
	"generic.upcoming": "Futuras",
	"generic.updated": "Actualizado",
	"generic.user": "Usuario",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Para inscribirte solo tienes que seguir el enlace facilitado por tu empresa u organización",
	"helpPage_carSharing_issue1_title": "¿Como me puedo inscribir?",
	"helpPage_carSharing_issue2_answer": "Puedes iniciar una recuperación de tu contraseña desde la aplicación móvil o desde la web. Recibirás un correo para establecer una nueva contraseña",
	"helpPage_carSharing_issue2_title": "He olvidado mi contraseña",
	"helpPage_carSharing_issue3_answer": "Si tienes una nueva tarjeta inteligente o perdiste la anterior, por favor, contactanos en Atención al Cliente para que deactivemos la tarjeta anterior. Una tarjeta nueva no funcionará hasta que realicemos este paso",
	"helpPage_carSharing_issue3_title": "¿Qué pasa si pierdo mi tarjeta inteligente o tengo una nueva?",
	"helpPage_carSharing_issue4_answer": "La matrícula del coche aparece en el email de confirmación de la reserva así como en la sección \"Mis Reservas\" de este sitio web",
	"helpPage_carSharing_issue4_title": "He olvidado que coche reservé",
	"helpPage_carSharing_issue5_answer": "Asegúrate de que la fecha y la hora de la reserva sean correctas. El botón Comenzar solo estará disponible cuando la reserva esté a punto de comenzar",
	"helpPage_carSharing_issue5_title": "No encuentro el botón Comenzar",
	"helpPage_carSharing_issue6_answer": "Si tienes una reserva y la luz verde se enciende pero las puertas no se abren, por favor, pulsa el botón localizado en el tirador de la puerta del conductor",
	"helpPage_carSharing_issue6_title": "¿Por qué la luz está verde pero las puertas siguen cerradas?",
	"helpPage_carSharing_issue7_answer": "Después de realizar una reserva tendrás la posibilidad de cambiarla o cancerlarla durante algún tiempo en la aplicación o llamando a Atención al Cliente",
	"helpPage_carSharing_issue7_title": "¿Cómo modifico o cancelo mi reserva?",
	"helpPage_carSharing_issue8_answer": "No es posible abrir el coche por adelantado. Para abrirlo deberás estar delante del coche durante el periodo de tu reserva y podrás abrir el coche una vez hayas iniciado tu reserva",
	"helpPage_carSharing_issue8_title": "¿Puedo abrir el coche antes?",
	"helpPage_damages_issue1_answer": "Antes de comenzar tu reserva, por favor, asegúrate de notificarnos sobre los desperfectos llamando a Atención al Cliente",
	"helpPage_damages_issue1_title": "El coche reservado tiene desperfectos",
	"helpPage_damages_issue2_answer": "Mantén la calma y asegúrate de que nadie haya resultado herido. Estás cubierto por una póliza de seguro. Contáctanos lo antes posible llamando a Atención al Cliente",
	"helpPage_damages_issue2_title": "He tenido un accidente",
	"helpPage_subtitle": "Aquí podrás encontrar respuesta a las preguntas que nos hacen más habitualmente",
	"helpPage_tab_carSharing": "Funcionamiento",
	"helpPage_tab_damages": "Incidencias",
	"helpPage_tab_vehicles": "Vehículo",
	"helpPage_title": "Preguntas frecuentes (F.A.Q)",
	"helpPage_vehicles_issue1_answer": "Comprueba la fecha y hora de tu reserva. Comprueba además que la matrícula del coche es la misma que figura en tu reserva",
	"helpPage_vehicles_issue1_title": "El vehículo no se abre ni responde",
	"helpPage_vehicles_issue2_answer": "Comprueba la fecha y hora de tu reserva. Comprueba además que la matrícula del coche es la misma que figura en tu reserva. Asegúrate que estás utilizando una tarjeta inteligente (smart card) adecuada",
	"helpPage_vehicles_issue2_title": "¿Por qué el lector de tarjetas muestra la luz roja?",
	"helpPage_vehicles_issue3_answer": "Necesitas conexión a Internet para poder comenzar tu reserva. Por favor, comprueba que ésta está activada y te encuentras en una zona con cobertura",
	"helpPage_vehicles_issue3_title": "No puedo comenzar mi reserva",
	"helpPage_vehicles_issue4_answer": "El PIN aparece en el reverso de la tarjeta de combustible que podrás encontrar en la guantera (donde estaban las llaves del vehículo). Asegúrate que la tarjeta y la estación de servicio pertenecen a la misma Red. Recuerda indicar el kilometraje actual al pagar",
	"helpPage_vehicles_issue4_title": "Uso de la tarjeta de combustible",
	"helpPage_vehicles_issue5_answer": "Asegúrate de que el motor esté apagado, las puertas y el maletero cerrados, las llaves estén en su emplazamiento original en la guantera y las ventanas subidas",
	"helpPage_vehicles_issue5_title": "¿Por qué no puedo cerrar el coche?",
	"home.header_banner": "En octubre, <strong> Renault Mobility </strong> se convertirá en <strong> Mobilize share </strong>",
	"home.welcome": "Bienvenido a {productName}",
	"home.welcome_solo": "Bienvenido",
	"how_it_works.step_1": "<span class='bold'>Descargue la aplicación</span> desde App Store o Google Play.",
	"how_it_works.step_2": "Inicie la aplicación y <span class='bold'>regístrese</span> completando el formulario.",
	"how_it_works.step_3": "Saque una foto a su <span class='bold'>permiso de conducir</span> y a su <span class='bold'>documento de identidad</span>, ¡guárdelo todo en la aplicación!",
	"how_it_works.step_4": "<span class='bold'>Registre su tarjeta bancaria</span> para administrar el pago de sus alquileres.",
	"how_it_works.step_5": "<span class='bold'>Valide su dirección de correo electrónico</span> haciendo clic en el enlace que se le envió. <span class='bold'>Revise sus carpetas de correo no deseado</span>.",
	"how_it_works.step_6": "Una vez que su registro esté validado, <span class='bold'>reserve su vehículo</span> en nuestra aplicación o en nuestra página web. El día de su reserva, <span class='bold'>¡su smartphone será su llave!</span>",
	"info.account.company.already.linked": "Esta empresa ya está vinculada a su cuenta",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Cambio de perfil",
	"info.worldpay.return.success": "Información de pago adjunta",
	"iso__BE": "Bélgica",
	"iso__CS": "República Checa",
	"iso__DA": "Danés",
	"iso__DE": "Alemania",
	"iso__ES": "España",
	"iso__FR": "Francia",
	"iso__IT": "Italia",
	"iso__NL": "Países Bajos",
	"iso__PL": "Polonia",
	"iso__PT": "Portugal",
	"iso__SL": "Eslovenia",
	"iso__SV": "Suecia",
	"iso__pt_BR": "Brasil",
	"label.accept_terms_and_conditions": "Acepto ser contactado posteriormente por Renault y su red por correo electrónico, con fines de investigación o información sobre nuevos productos, así como de ofertas actuales. En cada envío, tendré la posibilidad de finalizar toda comunicación.",
	"label.account.already.active": "Su cuenta ya está activada",
	"label.account_activation_description": "Recibirá una confirmación por correo electrónico cuando su cuenta sea validada y, después, podrá aprovechar al máximo el servicio.",
	"label.account_activation_title": "Su cuenta será validada en un máximo de 15 minutos.",
	"label.activation.link.expired": "El enlace de activación ha caducado",
	"label.activation.link.send": "Reenviar",
	"label.activation.link.sent.success": "El correo electrónico de activación se enviará si el usuario existe y la cuenta no está activada",
	"label.active.profile": "Perfil activo",
	"label.actual.payment.method": "Su método de pago actual",
	"label.add.new.profile": "Agregar nuevo perfil",
	"label.apply": "Aplicar",
	"label.are_you_sure_you_want_to_cancel": "¿Desea confirmar su cancelación?",
	"label.birth.day": "Fecha de nacimiento",
	"label.booking": "Reserva",
	"label.booking.past": "Realizadas",
	"label.booking.past.placeholder": "Encuentre aquí su historial de reservas.",
	"label.booking.today.part": "hoy a las",
	"label.booking.upcoming.placeholder": "Encuentre aquí sus reservas programadas y en curso",
	"label.cancel_my_booking": "Cancelar mi reserva",
	"label.car": "vehículo",
	"label.carSharing": "Auto compartido",
	"label.cars": "vehículos",
	"label.civility": "Tratamiento",
	"label.click_here": "Haga clic aquí",
	"label.close": "Cerrar",
	"label.confirm_new_password": "Confirmar contraseña",
	"label.congratulations": "¡Enhorabuena!",
	"label.continue": "Continuar",
	"label.creditCard_message": "Con el fin de validar su tarjeta, se realizará un cargo temporal. Un cargo por la cantidad de {amountToTake} € puede aparecer temporalmente en la cuenta asociada a su tarjeta. Si el cargo persiste durante más de cinco días laborables, póngase en contacto con su banco.",
	"label.date": "Fecha",
	"label.delivery_place": "Ciudad de expedición",
	"label.driving_licence": "Permiso de conducir",
	"label.driving_licence_back": "Permiso de conducir (reverso)",
	"label.driving_licence_front": "Permiso de conducir (anverso)",
	"label.edit.invite.code": "Editar código de invitación",
	"label.expiration_date": "Fecha de caducidad",
	"label.file.upload.only.mobile": "Para editar documentos, utilice la aplicación móvil.",
	"label.filter_by": "Filtrar por",
	"label.filters": "Filtros",
	"label.generic.error": "Se ha producido un error. Inténtelo de nuevo más tarde.",
	"label.hours": "horas",
	"label.how_it_works": "¿Cómo funciona?",
	"label.identity.card": "Documento de identidad",
	"label.identity.document.number": "Número de documento de identidad",
	"label.identity.document.type": "Tipo de documento de identidad",
	"label.identity_card": "Documento de identidad",
	"label.identity_card_back": "Documento de identidad (reverso)",
	"label.identity_card_front": "Documento de identidad (anverso)",
	"label.identity_card_selfie": "Selfie con su documento de identidad",
	"label.invite_code_placeholder": "Introduzca su código de invitación",
	"label.italy.fiscal.code": "Ingrese el número fiscal",
	"label.italy.resident": "¿Eres italiano?",
	"label.licence_number": "Número del permiso de conducir / Número de documento de identidad",
	"label.load_more": "Más resultados",
	"label.login": "Acceder",
	"label.logout": "Cerrar sesión",
	"label.manager.email": "Correo electrónico de su gerente",
	"label.mandatory_fields": "* Campos obligatorios",
	"label.member_already": "¿Ya es usted miembro?",
	"label.my_account": "Mi cuenta",
	"label.my_reservations": "Mis reservas",
	"label.new.password": "Contraseña nueva",
	"label.no_account": "¿Nuevo miembro?",
	"label.or_by_phone": "O por teléfono",
	"label.password": "Contraseña",
	"label.password_forgot": "Contraseña olvidada",
	"label.phone": "Número de teléfono",
	"label.phone.suffix": "Sufijo telefónico",
	"label.plateNumber": "Número de placa",
	"label.price": "precio",
	"label.redirectMobileApp": "Para iniciar su reserva, ¡descargue nuestra aplicación móvil!",
	"label.remember_me": "Permanecer conectado",
	"label.reset_password_done": "Su contraseña ha sido actualizada",
	"label.return": "Volver",
	"label.schedule": "Horas",
	"label.search": "Buscar",
	"label.selected.language": "Idioma seleccionado",
	"label.subject": "Asunto",
	"label.switch.profile": "Cambiar de perfil",
	"label.the": "a",
	"label.validate": "Validar",
	"label.vehicles_found": "{count} resultados encontrados",
	"label.warning": "Advertencia",
	"label.welcome.finish.registration": "Para confirmar su cita, finalice su registro.",
	"label.you_are_trying_to_cancel_your_booking": "¡Está a punto de cancelar su reserva!",
	"label.your.active.profile": "Tu perfil activo",
	"label.your.other.profiles": "Tus otros perfiles",
	"label.your_message": "Su mensaje",
	"language.header": "Seleccione su idioma",
	"login.forgot_password": "¿Olvidó su contraseña?",
	"login.register": "Registrarse",
	"menu.faq": "Información",
	"mobile_banner.text": "Descargar la aplicación {productName}",
	"page.password.update.sub.title": "Por razones de seguridad, le pedimos que actualice su contraseña.",
	"page.password.update.title": "Actualización de contraseña",
	"parking.special_opening_legend": "Horarios especiales de apertura",
	"part.company.fill.extra.info": "le pide que complete información adicional.",
	"part.complete.register.for": "Complete su registro en",
	"part.create.account.for": "Crear una cuenta para",
	"part.link.account.to": "Vincula tu cuenta a",
	"part.your.email": "tu email",
	"placeholder.enter.number": "Introduzca un número ...",
	"placeholder.enter.text": "Escriba aquí ...",
	"placeholder.search": "Buscar ...",
	"profile.422.error.info": "Parece que falta información en tu perfil.\n Verifiquemos juntos su perfil para asegurarnos de que todo esté bien.",
	"profile.info.new.email": "Si actualiza su dirección de correo electrónico, recibirá un correo electrónico para verificar su dirección de correo electrónico. Si no lo verifica, ya no podrá realizar una reserva.",
	"profile.label.before.arrival": "Antes de la llegada",
	"profile.label.before.departure": "Antes de la salida",
	"profile.label.charges.call.center": "Para cambios realizados en mi nombre",
	"profile.label.charges.my": "Para cambios realizados por mi",
	"profile.label.current.password": "Contraseña actual",
	"profile.label.expiration.date.status": "Mi licencia de conducir no tiene fecha de vencimiento",
	"profile.label.min.15": "15 minutos",
	"profile.label.min.30": "30 minutos",
	"profile.label.min.45": "45 minutos",
	"profile.label.new.email": "Nueva dirección de correo electrónico",
	"profile.label.street.field": "Dirección de residencia / Domicilio",
	"profile.label.validated.email": "Su dirección de correo electrónico validada",
	"profile.section.additional.info": "Información adicional",
	"profile.section.credentials": "Contraseñas",
	"profile.section.language": "Lenguaje de perfil",
	"profile.section.notifications": "Notificaciones y alertas",
	"profile.section.payment.info": "Método de pago",
	"profile.section.personal.info": "Datos personales",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Acceso técnico",
	"profile.select.menu.item": "Seleccione un elemento del menú a la izquierda",
	"profile.selfie.section.info": "Sáquese una foto selfie, mostrando su documento de identidad junto a su cara.",
	"profile.suspended": "Tu perfil está suspendido",
	"profile.title.email.notifications": "Notificaciones por email",
	"profile.title.language.select": "Idioma utilizado para notificaciones y correos electrónicos",
	"profile.title.sms.notifications": "Notificaciones por SMS",
	"profile.title.update.email": "Actualice su dirección de correo electrónico",
	"profile.title.update.password": "Actualizar su contraseña",
	"profile_error_driver_license_invalid": "El permiso de conducir no es válido",
	"register.field.info.password": "Debe contener al menos un dígito, una letra mayúscula, una letra minúscula y entre 8 y 25 caracteres",
	"register.info.payment.saved": "Se ha guardado el método de pago.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Se ha enviado un correo de activación a {email}. Compruebe su correo electrónico y la carpeta de correo no deseado, después, siga las instrucciones para activar su cuenta antes de que el link expire.",
	"register.terms.ads": "Doy mi consentimiento para el procesamiento de mis datos con fines de marketing (tanto con métodos automatizados como tradicionales) en relación con productos y / o servicios de movilidad",
	"register.terms.prefix.accept": "Acepto la",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "política de privacidad",
	"register.terms.root.tos": "condiciones de suscripción",
	"register.terms.root.tou": "condiciones de uso",
	"register.terms.suffix.ads": "uso de mis datos con fines comerciales",
	"register.terms.suffix.of": "de",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Enhorabuena {firstName}, tu cuenta ha sido creada",
	"register.title.account.linked": "Felicidades {firstName}, se ha vinculado un nuevo perfil a su cuenta",
	"register.title.account.updated": "Enhorabuena {firstName}, su cuenta ha sido actualizada",
	"reset_password.title": "Restablecimiento de contraseña",
	"search.filter_alphabetically": "En orden alfabético",
	"search.filter_by": "Ordenar por",
	"search.filter_by_price": "Por precio",
	"search.result.empty": "No hay ningún resultado",
	"service.corporate.intro": "¿Quiere unirse a una comunidad? Introduzca su código de invitación.",
	"service.intro_label": "¿A qué servicio de {productName} le gustaría suscribirse?",
	"service.private.intro": "¿Quiere reservar un vehículo de la red {productName}?",
	"service.private.renaultfr": "Para suscribirse a {productName}, descargue la aplicación en su tienda móvil.",
	"service.private.select_country": "Seleccione un país",
	"service.usage.corporate": "Coche compartido corporativo",
	"service.usage.private": "Alquiler de automóviles 24/7",
	"service.usage.vr": "Vehículo de reemplazo",
	"service.vr.intro": "¡Gracias por su interés en nuestro servicio! \n\nPara convertirse en miembro, póngase en contacto con su distribuidor para obtener un enlace de registro.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Ingrese su dirección de correo electrónico del trabajo",
	"sso.login.title": "Conéctese con SSO",
	"status.APPROVED": "Perfil validado",
	"status.NOT_APPROVED": "Su perfil es rechazado. Actualice su perfil.",
	"status.TO_COMPLETE": "Incompleto",
	"status.TO_REVIEW": "Tu perfil está pendiente de validación",
	"tagline": "Autoservicio de alquiler de automóviles 24/7",
	"title.add.payment.later": "Puedes agregarlo más tarde.",
	"title.add.payment.method": "Añada un método de pago.",
	"title.bookings.welcome.tutorial": "Encuentra aquí tu reserva, ya está programada",
	"title.modify.booking": "Modificar mi reserva",
	"title.password.change.success": "La nueva contraseña se ha actualizado de forma correcta",
	"title.update.booking": "Actualizar reserva",
	"title.welcome.to.brand": "Hola {firstName}, bienvenido a {brandName}.",
	"title.welcome.to.program": "Hola, {firstName}, bienvenido al programa {brandName} {program}.",
	"vehicle.incorrect.usage": "El vehículo no está disponaible para este tipo de uso",
	"week.day.friday": "Viernes",
	"week.day.monday": "Lunes",
	"week.day.saturday": "Sábado",
	"week.day.sunday": "Domingo",
	"week.day.thursday": "Jueves",
	"week.day.tuesday": "Martes",
	"week.day.wednesday": "Miércoles"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/es.json
 ** module id = 422
 ** module chunks = 0
 **/